<template>
  <div class="hot-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input placeholder="请输入城市名称" size="small" class="param-input" v-model="param.city"></el-input>
      <el-button type="primary" size="small" @click="getHotCity()">搜索</el-button>
      <el-button type="primary" size="small" @click="addCity('add')">新增城市</el-button>
    </div>
    <!--数据表格-->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" @sort-change="handleSortChange">
      <el-table-column prop="id" label="ID" align="center"></el-table-column>
      <el-table-column prop="city" label="城市" align="center"></el-table-column>
      <el-table-column prop="province" label="省" align="center"></el-table-column>
      <el-table-column prop="sortKey" label="排序" align="center" :sortable="'custom'"></el-table-column>
      <el-table-column prop="sortKey" label="状态" align="center">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.enable" disabled></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="更新时间" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.updatedAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center">
        <template slot-scope="scope">
          <span> {{(scope.row.createdAt || '未知') |  changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="160">
        <template slot-scope="scope">
          <el-button type="success" size="mini" class="el-icon-edit" @click="addCity('edit', scope.row)"></el-button>
          <el-button type="danger" size="mini" class="el-icon-delete" @click="remove(scope.row.id)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination :page-sizes="[10,15,20,25]" :current-page="param.pageNumber" :page-size="param.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    <!--新增、编辑tag弹窗-->
    <add-city ref="addCity" @handlerCity="getHotCity"></add-city>
  </div>
</template>
<script>
import AddCity from './components/addCity'
import API from '@/api'
import { sortEscape } from '@/utils/global'

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      tableData: [],
      total: 0,
      // 获取列表参数
      param: {
        pageNumber: 1,
        pageSize: 10,
        key: '',
        value: '',
        city: '',
        province: '',
      }
    }
  },
  components: {
    AddCity
  },
  created() {
    this.getHotCity()
  },
  methods: {
    // 获取热门城市列表
    getHotCity() {
      this.loading = true
      API.getHotCityList(this.param).then(res => {
        if (res.code === 200 && res.data.list) {
          this.tableData = res.data.list
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 新增热门城市
    addCity(type, data) {
      this.$refs.addCity.open(type, data)
    },
    // 删除热门城市
    remove(id) {
      this.$confirm('确定要删除当前热门城市吗？', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        API.deleteHotCity({ idArray: [id] }).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '删除成功！',
              type: 'success'
            });
            this.getHotCity()
          } else {
            this.$message.error('删除失败！');
          }
        })
      })
    },
    // 数据排序
    handleSortChange(column) {
      if (column.order) {
        this.param.value = sortEscape(column.order)
        this.param.key = column.prop;
      } else {
        this.param.value = ''
        this.param.key = '';
      }
      this.getHotCity()
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.param.pageSize = size
      this.param.pageNumber = 1
      this.getHotCity()
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.param.pageNumber = pageNumber
      this.getHotCity(this.param)
    }
  }
}
</script>
